export class AuthUtilities {
    private refreshWhenTokenValidated: boolean = false;

    constructor() {
        setTimeout(() => this.refreshServerSideAccessToken(), 1000 * 3); // Wait 3 seconds before calling the initial auth token refresh.
    }

    public allowAuthRefreshToReloadPage() {
        this.refreshWhenTokenValidated = true;
    }

    private async refreshServerSideAccessToken() {
        const response = await fetch("/api/auth/UpdateAccessToken");
        if (response.status !== 200) {
            console.error("Failed to refresh server-side access token");
            setTimeout(() => this.refreshServerSideAccessToken(), 10 * 1000); // Try again in 10 seconds
            return;
        }

        const bodyText = await response.text();
        console.log(`Refreshed server-side access token - ${bodyText}`);

        // Set in Blazor if we're allowed to do a hard refresh.
        if (this.refreshWhenTokenValidated) {
            location.reload();
            return;
        }

        setTimeout(() => this.refreshServerSideAccessToken(), 5 * 60 * 1000); // Call every 5 minutes
    }
}
